import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '视频分类',
    links: [
      { name: '生活', path: '/category/lifestyle' },
      { name: '娱乐', path: '/category/entertainment' },
      { name: '美食', path: '/category/food' },
      { name: '旅行', path: '/category/travel' },
      { name: '科技', path: '/category/tech' },
      { name: '时尚', path: '/category/fashion' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '联系方式', path: '/about#contact' },
      { name: '用户口碑', path: '/about#testimonials' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { name: '常见问题', path: '/#faq' },
      { name: '使用指南', path: '/about' },
      { name: '内容合作', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-heading font-bold text-primary-500">蜜桃视频</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              精选高清视频内容平台，汇聚生活、娱乐、美食、旅行等多元类目，画质清晰、加载流畅，随时随地畅享视频乐趣。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 蜜桃视频 mitaovideo.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}